import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import styles from './style.css';
import LogicInstance from '../../comlink/Logic';
import { useLocation } from 'wouter-preact';

var GameBoard = function GameBoard(_ref) {
  var encodedBoard = _ref.encodedBoard;

  var _useLocation = useLocation(),
      _useLocation2 = _slicedToArray(_useLocation, 2),
      setLocation = _useLocation2[1];

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      board = _useState2[0],
      setBoard = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      playerNum = _useState4[0],
      setPlayerNum = _useState4[1];

  useEffect( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var instance, gameBoard;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!encodedBoard) {
              _context.next = 8;
              break;
            }

            _context.next = 3;
            return LogicInstance();

          case 3:
            instance = _context.sent;
            _context.next = 6;
            return instance.populateFromEncoded(encodedBoard);

          case 6:
            gameBoard = _context.sent;
            setBoard(mapInitialGameboard(gameBoard));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), []);

  var selectPlayer = function selectPlayer(playerNum) {
    setPlayerNum(playerNum);
  };

  var newBoard = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var instance, board;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setPlayerNum(0);
              _context2.next = 3;
              return LogicInstance();

            case 3:
              instance = _context2.sent;
              _context2.next = 6;
              return instance.populateBoard();

            case 6:
              board = _context2.sent;
              setBoard(mapInitialGameboard(board));
              _context2.t0 = setLocation;
              _context2.t1 = "/";
              _context2.next = 12;
              return instance.lastGeneratedEncoding;

            case 12:
              _context2.t2 = _context2.sent;
              _context2.t3 = _context2.t1.concat.call(_context2.t1, _context2.t2);
              (0, _context2.t0)(_context2.t3);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function newBoard() {
      return _ref3.apply(this, arguments);
    };
  }();

  var copyLinkToClipboard = function copyLinkToClipboard() {
    navigator.clipboard.writeText(window.location)["catch"](function (e) {
      throw e;
    });
  };

  var mapInitialGameboard = function mapInitialGameboard(gameboard) {
    return gameboard.map(function (row) {
      return row.map(function (column) {
        return _objectSpread(_objectSpread({}, column), {}, {
          selected: false
        });
      });
    });
  };

  var setSelectedState = function setSelectedState(row, column) {
    var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    var newBoard = _toConsumableArray(board);

    newBoard[row][column].selected = value;
    setBoard(newBoard);
  };

  var Rows = function Rows() {
    if (board.length === 0) {
      return [];
    }

    return board.map(function (row, rowIndex) {
      return row.map(function (column, columnIndex) {
        var params = {
          classNames: undefined
        };

        if ((column.id === 1 || column.id === 3) && playerNum === 1) {
          params.classNames = "".concat(styles.greenCard);
        } else if ((column.id === 2 || column.id === 3) && playerNum === 2) {
          params.classNames = "".concat(styles.blueCard);
        } else if (column.id === 4 && playerNum > 0 || column.id === 5 && playerNum === 1 || column.id === 6 && playerNum === 2) {
          params.classNames = "".concat(styles.assassinCard);
        } else {
          params.classNames = "".concat(styles.normalCard);
        }

        if (column.search) {
          params.classNames += " ".concat(styles.selected);
        }

        return h("div", {
          className: "".concat(styles.gamePiece, " ").concat(params.classNames),
          onClick: function onClick() {
            return setSelectedState(rowIndex, columnIndex, column.search);
          }
        }, column.word);
      });
    });
  };

  return h("div", null, h("div", {
    className: styles.playerSelect
  }, h("input", {
    type: "button",
    value: "New Board",
    onClick: newBoard,
    className: styles.button
  }), h("input", {
    type: "button",
    value: "Send this link to a friend",
    onClick: copyLinkToClipboard,
    className: styles.button
  })), h("div", {
    className: styles.playerSelect
  }, h("input", {
    type: "button",
    value: "Codemaster 1",
    onClick: function onClick() {
      return selectPlayer(1);
    },
    className: "".concat(styles.button, " ").concat(styles.greenCard)
  }), h("input", {
    type: "button",
    value: "Codemaster 2",
    onClick: function onClick() {
      return selectPlayer(2);
    },
    className: "".concat(styles.button, " ").concat(styles.blueCard)
  }), h("input", {
    type: "button",
    value: "Teammate",
    onClick: function onClick() {
      return selectPlayer(0);
    },
    className: "".concat(styles.button)
  })), h("div", {
    className: styles.container
  }, h(Rows, null)));
};

export default GameBoard;